import React from "react"
import PropTypes from "prop-types"
import Card from "@mui/material/Card"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import HeadingIcon from "../HeadingIcon"
import { keyframes } from "@emotion/react"

// アニメーションの定義
const blinkAnimation = keyframes`
  0% {
    background-color: #ffffff;
  }
  50% {
    background-color: #ffeeee;
  }
  100% {
    background-color: #ffffff;
  }
`

export interface HeadingInfoCardProps {
  color?: "primary" | "secondary" | "info" | "success" | "warning" | "error" | "light" | "dark"
  title: string
  count: string | number
  icon: string
  onClick?: () => void
}

const HeadingInfoCard: React.FC<HeadingInfoCardProps> = ({ color = "info", title, count, icon, onClick }) => {
  const countValue = parseInt(count.toString().match(/^\d+/)?.[0] || "0", 10)
  return (
    <Card
      sx={{
        cursor: onClick ? "pointer" : "default",
        transition: "all 0.2s ease-in-out",
        "&:hover": onClick
          ? {
              transform: "translateY(-4px)",
              boxShadow: "0 10px 20px rgba(0,0,0,0.1)"
            }
          : {},
        backgroundColor: "#ffffff",
        animation:
          color === "primary" && countValue > 0 ? `${blinkAnimation} 2s infinite alternate ease-in-out` : "none"
      }}
      onClick={onClick}
    >
      <MDBox display="flex" justifyContent="space-between" pt={1} px={2}>
        <HeadingIcon color={color} icon={icon} />
        <MDBox
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="flex-end"
          textAlign="right"
          lineHeight={1.25}
        >
          <MDTypography variant="h6" fontWeight="normal" color="text">
            {title}
          </MDTypography>
          <MDTypography variant="h2">{count}</MDTypography>
        </MDBox>
      </MDBox>
      <MDBox pb={2} px={2} />
    </Card>
  )
}

HeadingInfoCard.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "light", "dark"]),
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func
}

export default HeadingInfoCard
